export class DunningProcedureFilter {
    public IncludeInactive?: boolean;
}

export default DunningProcedureFilter;